<template>
  <div class="ui-space-table__col" @click="$emit('click')">
    <div class="ui-space-table__col-container -flex-">
      <component
        :is="text ? 'p' : 'div'"
        :class="[text ? 'ui-space-table__text' : 'ui-space-table__block']"
      >
        <slot />
      </component>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: true
    }
  }
};
</script>
